import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";

export type ResourceExplorerPercentBasedChartDataSeriesMapType = Map<
  string,
  Omit<HighchartsChartDataType["series"][0], "name">
>;

export const aggregateResourceExplorerPercentBasedChartDataSeriesMap = (
  chartData: HighchartsChartDataType | null,
) => {
  return chartData?.series?.reduce((result, item) => {
    result.set(item.name, {
      data: item.data,
      color: item.color,
    });

    return result;
  }, new Map() as ResourceExplorerPercentBasedChartDataSeriesMapType);
};
